import { render, staticRenderFns } from "./DebrisPartitionDialog.vue?vue&type=template&id=523f4ea1&scoped=true&"
import script from "./DebrisPartitionDialog.vue?vue&type=script&lang=js&"
export * from "./DebrisPartitionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f4ea1",
  null
  
)

export default component.exports